//Users
import AddCafForm from "../pages/caf_form/add.js";
import EditCafForm from "../pages/caf_form/edit.js";
import ListCafForm from "../pages/caf_form/index.js";

//Composers
import { CafFormComposer } from "../composers/CafFormComposer.js";
import { DashboardComposer } from "../composers/DashboardComposer.js";
// Guards
import AuthGuard from "../components/guards/AuthGuard.js";
import DashboardLayout from "../layouts/Dashboard.js";
import ProtectedLayout from "../layouts/ProtectedLayout.js";
import CafPage from "../pages/caf_form/components/CafPage.js";

const CafFormRoutes = {
  path: "caf",
  element: (
    <AuthGuard>
      <DashboardComposer>
        <DashboardLayout />
      </DashboardComposer>
    </AuthGuard>
  ),
  children: [
    {
      path: "add",
      element: (
        <ProtectedLayout>
          <CafFormComposer>
            <AddCafForm />
          </CafFormComposer>
        </ProtectedLayout>
      ),
    },
    {
      path: "edit",
      element: (
        <ProtectedLayout>
          <CafFormComposer>
            <EditCafForm />
          </CafFormComposer>
        </ProtectedLayout>
      ),
    },
    {
      path: "list",
      element: (
        <ProtectedLayout>
          <CafFormComposer>
            <ListCafForm />
          </CafFormComposer>
        </ProtectedLayout>
      ),
    },
    {
      path: "details",
      element: (
        <ProtectedLayout>
          <CafFormComposer>
            <CafPage />
          </CafFormComposer>
        </ProtectedLayout>
      ),
    },
  ],
};

export default CafFormRoutes;
